const ResetPassword = () => {
    return <h1>ResetPassword</h1>;
  };
  
  export default ResetPassword;